<template>
    <div
        class="d-flex justify-space-between align-center"
        :class="summaryBackgroundColor"
    >
        <div
            class="d-flex align-center"
        >
            <h4
                :class="textClass"
            >
                <slot
                    name="label"
                >
                    {{ appendLabel + ' ' + label + ' ' + prependLabel }}
                </slot>
            </h4>
        </div>

        <div
            class="d-flex align-center justify-end"
            style="width: 150px;"
        >
            <h4
                class="mr-1"
                :class="textClass"
            >
                <slot
                    name="value"
                >
                    {{ value }}
                </slot>
            </h4>

            <slot
                name="description"
            >
                <v-tooltip
                    bottom
                    v-if="description"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            :color="infoIconColor"
                            small
                        >
                            $mdiInformation
                        </v-icon>
                    </template>
                    <span v-html="description"/>
                </v-tooltip>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SummaryValue",

        props: {
            'border': {
                type: Boolean,
                default: false,
            },
            'object': {
                type: Object,
                default: () => ({})
            },
            'property': {
                type: String,
                default: 'keyplanMaxBenefit'
            },
            'small': {
                type: Boolean,
                default: false,
            },
            'inverted': {
                type: Boolean,
                default: false,
            },
            'greyed': {
                type: Boolean,
                default: false,
            },
            'noDescription': {
                type: Boolean,
                default: false,
            },
            'prependLabel': {
                type: String,
                default: ''
            },
            'appendLabel': {
                type: String,
                default: ''
            },
        },

        computed: {
            label() {
                if (typeof this.object !== 'undefined' && typeof this.object[this.property] !== 'undefined' && typeof this.object[this.property].label !== 'undefined' && this.object[this.property].label) {
                    return this.object[this.property].label;
                }

                return '';
            },
            description() {
                let description = '';


                if (this.noDescription) {
                    return description;
                }

                if (typeof this.object !== 'undefined' && typeof this.object[this.property] !== 'undefined' && typeof this.object[this.property].description !== 'undefined' && this.object[this.property].description) {
                    if (this.debug) {
                        description += this.property + ' - ';
                    }

                    description += this.object[this.property].description;
                }

                return description;
            },
            value() {
                let suffix = '';
                let value = 0;

                if (typeof this.object !== 'undefined' && typeof this.object[this.property] !== 'undefined' && typeof this.object[this.property].value !== 'undefined' && this.object[this.property].value) {
                    if (this.unlimited && (this.property === 'productMaximumIndemnity' || this.property === 'lppBenefits')) {
                        value = 'Unlimited';

                    } else if (this.property === 'selectedTermYears') {
                        return this.object[this.property].value + ' ' + this.object[this.property].suffix;
                    } else {
                        value = this.currencyFilter(this.object[this.property]);
                    }
                }

                if (typeof this.object !== 'undefined' && typeof this.object[this.property] !== 'undefined' && typeof this.object[this.property].suffix !== 'undefined' && this.object[this.property].suffix) {
                    suffix = ' ' + this.object[this.property].suffix;
                }

                return value + suffix;
            },
            textClass() {
                let css = this.$vuetify.theme.dark ? 'white--text' : 'primary--text';

                if (this.greyed) {
                    css = 'accent--text';
                }

                if (this.inverted) {
                    css = 'white--text';
                }

                if (this.small) {
                    css += ' summary-value-mobile';
                } else {
                    css += ' summary-value-desktop';
                }

                return css;
            },
            infoIconColor() {
                let css = 'grey lighten-1';

                if (this.greyed) {
                    css = 'grey';
                }

                return css;
            },
            summaryBackgroundColor() {
                let css = '';

                if (this.inverted) {
                    css = 'accent';
                }

                if (this.greyed && !this.$vuetify.theme.dark) {
                    css = 'grey lighten-3';
                }

                if (this.greyed && this.$vuetify.theme.dark) {
                    css = 'background';
                }

                return css;
            },

            debug() {
                return process.env.NODE_ENV !== 'production';
            }
        }
    }
</script>
